export const getUtcOffset = (): number => new Date().getTimezoneOffset() * -1;
